import { PayloadAction } from "@reduxjs/toolkit";
import { EmployeesState } from "../../models/EmployeesState";
import { CreateEmployeePayload } from "../../payload/CreateEmployee/CreateEmployeePayload";

const createEmployeeFetch = (state: EmployeesState, action: PayloadAction<CreateEmployeePayload>) => {
    state.isLoading = true;
}

export default createEmployeeFetch;